import BackendConnector from './backendConnector';

export default class CriteriaConfigHttpService {
    static getPositionCriteriaConfig() {
        return BackendConnector.get('/system/config/position/criteria');
    }

    static getDiversityCriteriaConfig() {
        return BackendConnector.get('/system/config/diversity/criteria');
    }

    static getCalibrationCriteriaConfig() {
        return BackendConnector.get('/system/config/calibration/criteria');
    }

    static getFastRatingCriteriaConfig() {
        return BackendConnector.get('/system/config/fastRating/criteria');
    }
}
